import { getDefaultConfig } from '@rainbow-me/rainbowkit';
import { defineChain, type Chain } from 'viem';
import { bsc, polygon, bscTestnet } from 'viem/chains';
import { WAGMI_CHAINS, APP_META } from './networks.generated';

// Well-known chains use viem's built-in definition (canonical metadata +
// multicall3) when an overlay sets `viemChain`. Keep this a small explicit map
// so bundlers tree-shake unused chains. Anything not listed (or with no
// `viemChain`, e.g. the custom LitVM Orbit rollup) is built from generated data.
const PRESETS: Record<string, Chain> = { bsc, polygon, bscTestnet };

// Wallet-facing EVM chains, derived from the generated per-environment network
// list (selected by REACT_APP_BRIDGE_ENV). One entry per exposed network.
export const chains = WAGMI_CHAINS.map((c) => {
  if (c.viemChain) {
    const preset = PRESETS[c.viemChain];
    if (preset) return preset;
    // eslint-disable-next-line no-console
    console.warn(
      `[wagmi] overlay viemChain "${c.viemChain}" (chain ${c.id}) not in preset ` +
        `allowlist — using a generated custom chain. Add it to PRESETS in wagmi.ts.`
    );
  }
  return defineChain({
    id: c.id,
    name: c.name,
    nativeCurrency: c.nativeCurrency,
    rpcUrls: { default: { http: [c.rpcUrl] } },
    blockExplorers: { default: { name: c.explorerName, url: c.explorerUrl } },
    testnet: c.testnet,
  });
});

if (chains.length === 0) {
  throw new Error(
    'wagmi: no chains configured — check REACT_APP_BRIDGE_ENV and its overlay.'
  );
}

export const config = getDefaultConfig({
  appName: APP_META.appName,
  projectId: APP_META.walletConnectProjectId,
  chains: chains as unknown as readonly [Chain, ...Chain[]],
  ssr: false,
});
